import Vue from 'vue'
import VtIconButton from '@/components/common/VtIconButton.vue'
Vue.component('VtIconButton', VtIconButton)
